import { get, isEmpty } from 'lodash/fp';
import { EmailProvider, MfaSettingsType } from '../../../../api/types';
import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

const validator = validators.compose(
    validators.requiredString('displayName'),
    validators.requiredString('companyName.defaultValue'),
    validators.requiredString('legalName.defaultValue'),
    validators.requiredString('countryCode'),
    validators.requiredNumber('coe'),
    validators.requiredNumber('ppsr'),
    validators.requiredNumber('estFee'),
    validators.requiredString('timeZone'),
    validators.requiredNumber('sessionTimeout'),
    validators.requiredBoolean('isActive'),
    validators.requiredBoolean('isDataPurgeEnabled'),
    validators.only(values => get('isDataPurgeEnabled', values), validators.requiredNumber('dataPurgeAfter')),
    validators.requiredBoolean('isInstantApprovalStatsEnabled'),
    validators.requiredString('email'),
    validators.validEmail('email'),
    validators.requiredString('currency'),
    validators.requiredString('copyright.defaultValue'),
    validators.requiredString('emailSettings.provider'),
    validators.only(
        values => !isEmpty(get('phone.value', values)),
        validators.compose(validators.requiredNumber('phone.prefix'))
    ),
    validators.only(
        values => get('emailSettings.provider', values) === EmailProvider.Smtp,
        validators.compose(
            validators.requiredString('emailSettings.from'),
            validators.validEmail('emailSettings.from'),
            validators.requiredString('emailSettings.host'),
            validators.requiredNumber('emailSettings.port'),
            validators.requiredBoolean('emailSettings.isSslEnabled'),
            validators.requiredBoolean('emailSettings.isAuthenticationRequired'),
            validators.only(
                values => get('emailSettings.isAuthenticationRequired', values),
                validators.compose(
                    validators.requiredString('emailSettings.user'),
                    validators.requiredString('emailSettings.password')
                )
            )
        )
    ),
    validators.only(
        values => values.mfaSettings.enabled,
        validators.requiredStringEnum('mfaSettings.type', MfaSettingsType)
    ),
    validators.requiredString('edmEmailFooter.connectText.defaultValue'),
    validators.requiredString('edmEmailFooter.copyRight.defaultValue'),

    validators.forEach(
        'edmEmailFooter.socialMedia',
        validators.only(
            (values, error, { prefix }) => {
                const value = get(prefix, values);
                const { url, icon } = value;

                return !!url || !isEmpty(icon);
            },
            validators.compose(validators.requiredUploadFile('icon'), validators.requiredString('url'))
        )
    ),

    validators.only(values => get('countryCode', values) === 'AE', validators.requiredString('marketCode')),

    validators.forEach(
        'vatRateSettings.vatRateTable',
        validators.compose(validators.requiredDate('startDate'), validators.requiredNumber('value'))
    )
);

const useCompanyFormValidator = () => useValidator(validator);

export default useCompanyFormValidator;
